import { Icon } from "AlignComponents";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
// @ts-ignore
import Fade from 'react-reveal/Fade';
import { GiMove } from 'react-icons/gi'
import { BiLinkExternal } from "react-icons/bi";
import { ArrayKeyValueObject, KeyValueObject } from "@/UI/Interfaces/IBaseUI";
import { useAppSelector } from "@/Hook/hooks";
import { IObjects } from "@/Redux/Ducks/dashboardSlice";

interface IProps {
	widgetno: string;
}

const formatValue = (val: any) => {
	if (typeof val === "number") {
		const isNegative = val < 0;
		val = Math.abs(val);

		if (val >= 1000000000) {
			return (isNegative ? '-' : '') + (val / 1000000000).toFixed(2) + "b";
		} else if (val >= 1000000) {
			return (isNegative ? '-' : '') + (val / 1000000).toFixed(2) + "m";
		} else if (val >= 1000) {
			return (isNegative ? '-' : '') + (val / 1000).toFixed(2) + "k";
		} else {
			return (isNegative ? '-' : '') + val;
		}
	} else {
		return val;
	}
};

const Information = ({ widgetno }: IProps) => {
	const widget = useAppSelector(x => x.Dashboard.activeWidget.objects.find(x => x.widgetno == widgetno)) as IObjects;
	const data = widget.data[0];

	const valueCol = widget.columns.find((x: any) => x.widgetobjecttypeno == 'VAL')?.objectno as string;
	const badgeCol = widget.columns.find((x: any) => x.widgetobjecttypeno == 'BDG')?.objectno as string;

	let value = formatValue(data[valueCol]);
	let badgeValue = badgeCol ? data[badgeCol].toString() : null
	let badgeColor = badgeCol ?
		(Number(badgeValue.replace(/%/g, '')) > 0 ?
			"success" : "danger") :
		null;
	let badgeIcon: any = badgeCol ?
		(Number(badgeValue.replace(/%/g, '')) > 0 ?
			"ArrowUp" : "ArrowDown") :
		null;

	const routeToScreen = () => {

	}

	if (widget) {
		return (
			<div className="information-card">
				<Fade>
					<Card>
						<Card.Body>
							{
								widget.widgetprocesscode ? (
									<OverlayTrigger placement="bottom" overlay={<Tooltip>Hyperlink</Tooltip>}>
										<div className="hyperlink" onClick={routeToScreen}>
											<BiLinkExternal size={12} />
										</div>
									</OverlayTrigger>
								) : null
							}
							<OverlayTrigger placement="bottom" overlay={<Tooltip>Move</Tooltip>}>
								<div className="drag-handle">
									<GiMove size={12} />
								</div>
							</OverlayTrigger>

							<div className="card-container">
								<div className="text-container">
									<span className="label">{widget.widgetstxt}</span>
									<span className="value">{value}</span>
									{
										badgeValue ? (
											<span
												className={`badge mt-2 bg-light-${badgeColor} text-${badgeColor} rounded-pill d-flex align-items-center gap-1 fs-10`}
												style={{ minWidth: '40px' }}>
												<Icon icon={badgeIcon} size={12} />
												{badgeValue}
											</span>
										) : null
									}
								</div>
								<div className={`icon border-light-${widget.widgetcolor}`}>
									<Icon
										icon={(widget.widgeticon as any)}
										className={`text-white bg-${widget.widgetcolor}`}
										size={50}
									/>
								</div>
							</div>
						</Card.Body>
					</Card>
				</Fade>
			</div >
		)
	}
	else return null;
}

export default Information;